import { ScanOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import React from 'react'

export const ScannerConnectedIndicator: React.FC = () =>
  <Tooltip title="Escáner conectado" placement="topRight" color="blue">
    <div className="ml-2 flex items-center justify-center h-8 bg-blue-100 border border-blue-500 rounded-md px-2 transition-all hover:scale-105 max-w-8">
      <ScanOutlined className="text-lg text-blue-600" />
    </div>
  </Tooltip>
